import { useMutation, useIsFetching } from "react-query";
import { activateDevice, deactivateDevice, dislikeDeviceCurrentTrack, pauseDevice, playDevice, playNextTrack, updateDevice, } from "frontend/src/api/devices";
import { notify } from "frontend/src/features/notifications";
import { queryClient } from "frontend/src/domain/query-client";
import { changeDeviceVolume } from "frontend/src/api/devices/volume";
import { cacheKey } from "./shared";
export var useDeleteDevice = function () { return useMutation(deactivateDevice); };
export var useUpdateDevice = function () {
    return useMutation(updateDevice, {
        onSuccess: function (_, _a) {
            var id = _a.id;
            queryClient.refetchQueries([cacheKey, id]);
            queryClient.invalidateQueries(cacheKey);
            notify({ variant: "success", message: "Устройство обновлено" });
        },
    });
};
export var useActivateDevice = function () {
    return useMutation(activateDevice, {
        onSuccess: function () {
            queryClient.invalidateQueries(cacheKey);
            notify({ variant: "success", message: "Устройство активировано" });
        },
    });
};
export var usePlayDevice = function () {
    return useMutation(playDevice, {
        onSuccess: function () {
            notify({ variant: "success", message: "Вещание запущено." });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "При начале вещания произошла ошибка.",
            });
        },
    });
};
export var usePlayNextTrackDevice = function () {
    return useMutation(playNextTrack, {
        onSuccess: function () {
            notify({ variant: "success", message: "Вещание запущено." });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "При начале вещания произошла ошибка.",
            });
        },
    });
};
export var useStopDevice = function () {
    return useMutation(pauseDevice, {
        onSuccess: function () {
            notify({ variant: "success", message: "Вещание остановлено." });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "При остановке вещания произошла ошибка.",
            });
        },
    });
};
export var useDislikeTrackDevice = function () {
    return useMutation(dislikeDeviceCurrentTrack, {
        onSuccess: function () {
            notify({
                variant: "success",
                message: "Вещание перешло к следующему треку.",
            });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "При переходе вещания к следующему треку произошла ошибка.",
            });
        },
    });
};
export var useRefreshDevice = function (id) {
    var refresh = function () { return queryClient.refetchQueries([cacheKey, id]); };
    var isLoading = useIsFetching([cacheKey, id]) === 1;
    return { run: refresh, isLoading: isLoading };
};
export var useUpdateDeviceVolume = function () {
    return useMutation(changeDeviceVolume, {
        onSuccess: function () {
            notify({ variant: "success", message: "Громкость вещания изменена." });
        },
        onError: function () {
            notify({
                variant: "error",
                message: "При изменении громкости вещания произошла ошибка.",
            });
        },
    });
};
